import React from 'react';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import CloudQueueOutlinedIcon from '@mui/icons-material/CloudQueueOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';

const AIInnovation = () => {
  return (
    <div className="ai-banner">
      <div className="container ai-banner-content">
        <div className="ai-banner-left">
          <span className="tag">AI & INNOVATION</span>
          <h2>Intelligent Solutions for a Smarter Future</h2>
          <div className="divider-short"></div>
        </div>
        <div className="ai-banner-icons">
          <div className="ai-icon-item">
            <SmartToyOutlinedIcon fontSize="large" style={{ color: 'var(--color-bg)' }} />
            <span>AI Assistants</span>
          </div>
          <div className="ai-icon-item">
            <SettingsSuggestOutlinedIcon fontSize="large" style={{ color: 'var(--color-bg)' }} />
            <span>Automation</span>
          </div>
          <div className="ai-icon-item">
            <AccountTreeOutlinedIcon fontSize="large" style={{ color: 'var(--color-bg)' }} />
            <span>Smart Workflows</span>
          </div>
          <div className="ai-icon-item">
            <CloudQueueOutlinedIcon fontSize="large" style={{ color: 'var(--color-bg)' }} />
            <span>Cloud Integrations</span>
          </div>
          <div className="ai-icon-item">
            <DashboardCustomizeOutlinedIcon fontSize="large" style={{ color: 'var(--color-bg)' }} />
            <span>Digital Transformation</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIInnovation;
